import React from "react";
import styles from "../styles/habitaciones.module.css";

export default function HabitacionesKpis({ kpi }) {
    return (
        <div className={styles.kpis}>
            <div className={styles.kpi}>
                <span className={styles["kpi-title"]}>Total</span>
                <span className={styles["kpi-value"]}>{kpi.total}</span>
            </div>
            <div className={styles.kpi}>
                <span className={styles["kpi-title"]}>Disponibles</span>
                <span className={styles["kpi-value"]}>{kpi.libres}</span>
            </div>
            <div className={styles.kpi}>
                <span className={styles["kpi-title"]}>No disp.</span>
                <span className={styles["kpi-value"]}>{kpi.ocupadas}</span>
            </div>
        </div>
    );
}
